import { toCurrencyString } from '@thesavingsgroup/utils/toCurrencyString';
import { toDOBString } from '@thesavingsgroup/utils/toDOBString';
import { toNumberString } from '@thesavingsgroup/utils/toNumberString';
import { toPhoneString } from '@thesavingsgroup/utils/toPhoneString';
import { toSSNString } from '@thesavingsgroup/utils/toSSNString';

export const formatValue = (
  value: string,
  currency: boolean,
  phone: boolean,
  ssn: boolean,
  dob: boolean,
): string => {
  if (ssn) {
    return toSSNString(value);
  }

  if (dob) {
    return toDOBString(value);
  }

  if (phone) {
    return toPhoneString(value);
  }

  if (currency) {
    return toCurrencyString(value);
  }

  return toNumberString(value);
};
